import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import usbServices from "./usb-services.js";
import Utility from "@/shared/utility.js";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      selectedProject: [],
      selectedBusiness: [],
      selectedCountry: [],
      selectedWorkflow: [],
      hasPendingConfigFilterChanges: false,
      isApplyingConfigFilters: false,
      configPendingApplyTimer: null,
      suppressNextConfigFilterChange: false,
      projectList: [],
      businessList: [],
      countryList: [],
      workflowList: [],
      showPrimary: true,
      printDisable: true,
      printerConfigured: false,
      labelValue: false,
      configSourcingHeaders: [
        { text: "", value: "shipping_hold", align: "center", class: "primary customwhite--text", sortable: false, width: "34px" },
        { text: "SLA", value: "SLA", align: "center", class: "primary customwhite--text" },
        { text: "Workflow", value: "workflow", class: "primary customwhite--text" },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        { text: "Project", value: "project", class: "primary customwhite--text" },
        { text: "RLP Order", value: "sono", class: "primary customwhite--text" },
        { text: "Customer ID", value: "TaskID", class: "primary customwhite--text" },
        { text: "Part Number", value: "part_num", class: "primary customwhite--text" },
        { text: "Location", value: "sh_country", class: "primary customwhite--text" },
        { text: "Allocation Date", value: "relativetime", class: "primary customwhite--text" },
        { text: "Progress", value: "progress", class: "primary customwhite--text" },
        { text: "Actions", value: "action", class: "primary customwhite--text" },
      ],
      configSourcingData: [],
      configSourcingDataTemp: [],
      activeDashboardFilter: "",
      configDashboardSummary: {
        total: 0,
        hold: 0,
        slaCounts: {},
        assigned: 0,
        unassigned: 0,
        statusBreakdown: [],
      },
      totalRecords: 0,
      searchRules: [(v) => !!v || "Search is required"],
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      configurationSourcingForm: false,
      search: "",
      searchFilter: "",
      lpnText: "",
      lpnNum: "",
      dropOffLPNDialog: false,
      userAssignedLPN: "",
      stagingLocationLPN: "",
      dropLPN: false,
      lpnKey: "",
      lineKeys: [],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.applyConfigPrinterToggle(JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue")));
      if (this.labelValue && this.printerConfigured) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Default Printer is not configured, please configure printer",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    }
    await this.getConfigurationDDL();
    this.sourceConfigLoadSourcedLine();
    this.getBreadCrumbLPN();
    await this.getSearch();
    this.interval = setInterval(() => {
      if (this.hasSelectedConfigFilters) {
        this.filterSearch();
      }
    }, 120000);
  },
  destroyed() {
    clearInterval(this.interval);
    if (this.configPendingApplyTimer) {
      clearTimeout(this.configPendingApplyTimer);
    }
  },
  computed: {
    hasSelectedConfigFilters() {
      return Boolean(
        this.selectedProject?.length ||
        this.selectedBusiness?.length ||
        this.selectedCountry?.length ||
        this.selectedWorkflow?.length
      );
    },
    showConfigDashboard() {
      return Boolean(this.configSourcingDataTemp?.length);
    },
    configDashboardCards() {
      return [
        {
          label: "Total Orders",
          value: this.configDashboardSummary.total,
          icon: "mdi-view-dashboard-outline",
          color: "#2563eb",
          filterType: "all",
        },
        {
          label: "Shipping Hold",
          value: this.configDashboardSummary.hold,
          icon: "mdi-truck-alert-outline",
          color: "#dc2626",
          filterType: "hold",
        },
        {
          label: "On-Time",
          value: this.configDashboardSummary.slaCounts["ON-TIME"] || 0,
          icon: "mdi-clock-check-outline",
          color: "#16a34a",
          filterType: "sla:ON-TIME",
        },
        {
          label: "Must Ship",
          value: this.configDashboardSummary.slaCounts["MUST SHIP"] || 0,
          icon: "mdi-alert-circle-outline",
          color: "#f59e0b",
          filterType: "sla:Must Ship",
        },
        {
          label: "Past Due",
          value: this.configDashboardSummary.slaCounts["PAST DUE"] || 0,
          icon: "mdi-clock-alert-outline",
          color: "#dc2626",
          filterType: "sla:Past Due",
        },
        {
          label: "Awaiting Sourcing",
          value: this.configDashboardSummary.unassigned,
          icon: "mdi-timer-sand",
          color: "#64748b",
          filterType: "unassigned",
        },
        {
          label: "Sourcing in Progress",
          value: this.configDashboardSummary.assigned,
          icon: "mdi-account-clock-outline",
          color: "#f59e0b",
          filterType: "assigned",
        },
      ];
    },
  },
  methods: {
    hasHoldPrefix(orderNo) {
      return String(orderNo || "")
        .replace(/<[^>]*>/g, "")
        .toUpperCase()
        .includes("[HOLD]-");
    },
    updateConfigTableData(data) {
      this.configSourcingData = data;
      this.configSourcingDataTemp = data;
      this.totalRecords = data?.length || 0;
      this.activeDashboardFilter = "";
      this.configDashboardSummary = this.buildConfigDashboardSummary(data);
    },
    statusValue(item) {
      return String(item?.status || "").replace(/<[^>]*>/g, "").trim();
    },
    isAssignedItem(item) {
      return String(item?.cansource ?? "0") !== "0";
    },
    isUnassignedItem(item) {
      return String(item?.cansource ?? "0") === "0";
    },
    buildConfigDashboardSummary(sourceData) {
      const total = sourceData?.length || 0;
      const statusCounts = {};
      const slaCounts = {};
      let hold = 0;
      let assigned = 0;
      let unassigned = 0;
      (sourceData || []).forEach((item) => {
        const status = this.statusValue(item) || "Unassigned";
        const sla = this.normalizeSla(item);
        statusCounts[status] = (statusCounts[status] || 0) + 1;
        if (sla) slaCounts[sla] = (slaCounts[sla] || 0) + 1;
        if (this.hasHoldPrefix(item?.sono)) hold += 1;
        if (this.isAssignedItem(item)) assigned += 1;
        if (this.isUnassignedItem(item)) unassigned += 1;
      });
      const statusColors = ["#2563eb", "#16a34a", "#f59e0b", "#dc2626", "#7c3aed", "#0891b2"];
      const statusBreakdown = Object.entries(statusCounts)
        .sort((a, b) => b[1] - a[1])
        .map(([status, count], index) => ({
          status,
          total: count,
          percent: total ? (count / total) * 100 : 0,
          color: statusColors[index % statusColors.length],
        }));
      return {
        total,
        hold,
        slaCounts,
        assigned,
        unassigned,
        statusBreakdown,
      };
    },
    formatDashboardNumber(value) {
      return new Intl.NumberFormat().format(value || 0);
    },
    rawSlaValue(item) {
      return String(item?.SLA || item?.sla || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
    },
    normalizeSla(item) {
      const sla = this.rawSlaValue(item).toUpperCase();
      const compactSla = sla.replace(/[\s-_]/g, "");
      if (compactSla.includes("ONTIME")) return "ON-TIME";
      if (compactSla.includes("MUSTSHIP")) return "MUST SHIP";
      if (compactSla.includes("PASTDUE")) return "PAST DUE";
      return sla;
    },
    slaDisplay(item) {
      return this.normalizeSla(item) || "-";
    },
    formatShipByDate(shipByDate) {
      return Utility.displayDateFormat(shipByDate, "MM/DD/YYYY");
    },
    slaDotColor(item) {
      const sla = this.normalizeSla(item);
      if (sla === "ON-TIME") return "#16a34a";
      if (sla === "MUST SHIP") return "#f59e0b";
      if (sla === "PAST DUE") return "#dc2626";
      return "#64748b";
    },
    filterDashboardQueue(type, value = "") {
      let normalizedType = type;
      let normalizedValue = value;
      if (type?.includes(":")) {
        const filterParts = type.split(":");
        normalizedType = filterParts[0];
        normalizedValue = filterParts.slice(1).join(":");
      }
      const sourceData = this.configSourcingDataTemp || [];
      const filters = {
        all: () => sourceData,
        hold: () => sourceData.filter((item) => this.hasHoldPrefix(item?.sono)),
        assigned: () => sourceData.filter((item) => this.isAssignedItem(item)),
        unassigned: () => sourceData.filter((item) => this.isUnassignedItem(item)),
        sla: () => sourceData.filter((item) => this.normalizeSla(item) === normalizedValue.toUpperCase()),
        status: () => sourceData.filter((item) => this.statusValue(item) === normalizedValue),
      };
      this.activeDashboardFilter = normalizedType === "status" || normalizedType === "sla" ? `${normalizedType}:${normalizedValue}` : normalizedType;
      const filteredData = (filters[normalizedType] || filters.all)();
      this.configSourcingData = filteredData;
      this.totalRecords = filteredData?.length || 0;
    },
    getConfigFilterConfig(filterName) {
      return {
        project: { selectedKey: "selectedProject", itemKey: "proj_key", textKey: "project" },
        business: { selectedKey: "selectedBusiness", itemKey: "bu_key", textKey: "business" },
        country: { selectedKey: "selectedCountry", itemKey: "country", textKey: "country" },
        workflow: { selectedKey: "selectedWorkflow", itemKey: "workflow", textKey: "workflow" },
      }[filterName];
    },
    getConfigFilterSelectionValue(filterName, item) {
      const filterConfig = this.getConfigFilterConfig(filterName);
      if (!filterConfig) return item;
      return filterConfig.itemKey ? item?.[filterConfig.itemKey] ?? item : item;
    },
    getConfigFilterSelectionText(filterName, item) {
      const filterConfig = this.getConfigFilterConfig(filterName);
      if (!filterConfig) return item;
      return filterConfig.textKey ? item?.[filterConfig.textKey] ?? item : item;
    },
    async removeConfigFilterSelection(filterName, item, filterRef = "") {
      const filterConfig = this.getConfigFilterConfig(filterName);
      if (!filterConfig) return;
      const removedValue = this.getConfigFilterSelectionValue(filterName, item);
      this[filterConfig.selectedKey] = (this[filterConfig.selectedKey] || []).filter(
        (value) => String(value) !== String(removedValue)
      );
      this.hasPendingConfigFilterChanges = true;
      await this.applyConfigFilters(filterRef);
    },
    async clearConfigFilterSelection(filterName, filterRef = "") {
      const filterConfig = this.getConfigFilterConfig(filterName);
      if (!filterConfig) return;
      this.suppressNextConfigFilterChange = true;
      this[filterConfig.selectedKey] = [];
      this.hasPendingConfigFilterChanges = true;
      try {
        await this.$nextTick();
        await this.applyConfigFilters(filterRef);
        await this.$nextTick();
      } finally {
        this.suppressNextConfigFilterChange = false;
      }
    },
    async onConfigFilterSelectionChange(filterRef = "") {
      if (this.suppressNextConfigFilterChange) return;
      this.$refs.configurationSourcing?.resetValidation();
      this.hasPendingConfigFilterChanges = true;
      await this.$nextTick();
      if (!this.isConfigFilterDropdownOpen(filterRef)) {
        await this.applyConfigFilters(filterRef);
      }
    },
    applyPendingConfigFilters(filterRef = "") {
      if (!this.hasPendingConfigFilterChanges || this.isApplyingConfigFilters) return;
      if (this.configPendingApplyTimer) {
        clearTimeout(this.configPendingApplyTimer);
      }
      this.configPendingApplyTimer = setTimeout(async () => {
        this.configPendingApplyTimer = null;
        if (this.hasPendingConfigFilterChanges && !this.isApplyingConfigFilters) {
          await this.applyConfigFilters(filterRef);
        }
      }, 150);
    },
    async applyConfigFilters(filterRef = "") {
      if (this.isApplyingConfigFilters) return;
      if (this.configPendingApplyTimer) {
        clearTimeout(this.configPendingApplyTimer);
        this.configPendingApplyTimer = null;
      }
      this.isApplyingConfigFilters = true;
      try {
        await this.filterSearch();
        this.hasPendingConfigFilterChanges = false;
        this.closeConfigFilterDropdown(filterRef);
      } finally {
        this.isApplyingConfigFilters = false;
      }
    },
    closeConfigFilterDropdown(filterRef) {
      if (!filterRef || !this.$refs?.[filterRef]) return;
      this.$nextTick(() => {
        const filter = this.$refs[filterRef];
        if (filter?.blur) filter.blur();
        if (filter?.isMenuActive !== undefined) filter.isMenuActive = false;
      });
    },
    isConfigFilterDropdownOpen(filterRef) {
      if (!filterRef || !this.$refs?.[filterRef]) return false;
      return Boolean(this.$refs[filterRef]?.isMenuActive);
    },
    clearPersistedConfigFilters() {
      EncryptUtility.localStorageEncrypt("configSourcingFilters", "");
      EncryptUtility.localStorageRemoveItem("CSProject");
      EncryptUtility.localStorageRemoveItem("CSProjectData");
      EncryptUtility.localStorageRemoveItem("CSBusiness");
      EncryptUtility.localStorageRemoveItem("CSBusinessData");
      EncryptUtility.localStorageRemoveItem("CSCountry");
      EncryptUtility.localStorageRemoveItem("CSCountryData");
      EncryptUtility.localStorageRemoveItem("CSWorkflow");
      EncryptUtility.localStorageRemoveItem("CSWorkflowData");
    },
    buildConfigFilterSearchPayload() {
      const json = JSON.stringify({
        projkey_list: this.selectedProject,
        bukey_list: this.selectedBusiness,
        country_list: this.selectedCountry,
        wf_list: this.selectedWorkflow,
        label: this.labelValue,
        label_value: this.labelValue,
      });
      return {
        userid: this.userId,
        json: json,
      };
    },
    parseConfigDbFilterResponse(response) {
      const data = response?.data?.body?.message ?? response?.data?.body ?? response?.data?.message ?? response?.data;
      if (typeof data === "string") {
        try {
          return JSON.parse(data);
        } catch (error) {
          return data;
        }
      }
      return data;
    },
    async postConfigDbFilters(obj) {
      try {
        const response = await this.axios.post("wc/sourcing_queue_save_filters", obj);
        console.debug("wc/sourcing_queue_save_filters response", {
          pass: obj?.pass,
          status: response?.status,
          body: response?.data,
        });
        if (response?.status === 204) return { message: "NA" };
        if (response?.status === 200) return this.parseConfigDbFilterResponse(response);
        return { message: response?.data?.message || "NA" };
      } catch (error) {
        console.error("wc/sourcing_queue_save_filters error", {
          pass: obj?.pass,
          payload: obj,
          response: error?.response,
          message: error?.message,
        });
        return { message: "NA" };
      }
    },
    normalizeSavedConfigFilterList(value) {
      if (Array.isArray(value)) return value;
      if (value === undefined || value === null || value === "") return [];
      return [value];
    },
    normalizeSavedConfigPrinterToggle(value) {
      if (value === true || value === false) return value;
      if (value === 1 || value === "1") return true;
      if (value === 0 || value === "0") return false;
      if (typeof value === "string") {
        const normalizedValue = value.trim().toLowerCase();
        if (["true", "yes", "y", "on"].includes(normalizedValue)) return true;
        if (["false", "no", "n", "off"].includes(normalizedValue)) return false;
      }
      return false;
    },
    hasSavedConfigPrinterToggle(savedFilters) {
      return (
        savedFilters &&
        (Object.prototype.hasOwnProperty.call(savedFilters, "label") ||
          Object.prototype.hasOwnProperty.call(savedFilters, "label_value") ||
          Object.prototype.hasOwnProperty.call(savedFilters, "LabelSwitchValue"))
      );
    },
    getSavedConfigPrinterToggle(savedFilters) {
      if (Object.prototype.hasOwnProperty.call(savedFilters, "label")) return savedFilters.label;
      if (Object.prototype.hasOwnProperty.call(savedFilters, "label_value")) return savedFilters.label_value;
      return savedFilters.LabelSwitchValue;
    },
    applyConfigPrinterToggle(value) {
      this.labelValue = this.normalizeSavedConfigPrinterToggle(value);
      EncryptUtility.localStorageEncrypt("LabelSwitchValue", JSON.stringify(this.labelValue));
      if (this.labelValue && EncryptUtility.localStorageDecrypt("defaultName") !== null && EncryptUtility.localStorageDecrypt("defaultName") !== undefined) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else if (this.labelValue) {
        this.printDisable = true;
        this.printerConfigured = true;
      } else {
        this.printDisable = true;
        this.printerConfigured = false;
      }
    },
    parseSavedConfigFilters(savedFilters) {
      if (Array.isArray(savedFilters)) {
        savedFilters = savedFilters[0];
      }
      if (typeof savedFilters === "string") {
        try {
          savedFilters = JSON.parse(savedFilters);
        } catch (error) {
          return null;
        }
      }
      const savedJson = savedFilters?.json ?? savedFilters?.Json ?? savedFilters?.JSON;
      if (typeof savedJson === "string") {
        try {
          const parsedFilters = JSON.parse(savedJson);
          if (this.hasSavedConfigPrinterToggle(savedFilters) && !this.hasSavedConfigPrinterToggle(parsedFilters)) {
            parsedFilters.label = this.getSavedConfigPrinterToggle(savedFilters);
          }
          savedFilters = parsedFilters;
        } catch (error) {
          return null;
        }
      }
      return savedFilters;
    },
    applySavedConfigFilters(savedFilters) {
      savedFilters = this.parseSavedConfigFilters(savedFilters);
      if (!savedFilters || typeof savedFilters !== "object") return false;
      this.selectedProject = this.normalizeSavedConfigFilterList(savedFilters.projkey_list);
      this.selectedBusiness = this.normalizeSavedConfigFilterList(savedFilters.bukey_list);
      this.selectedCountry = this.normalizeSavedConfigFilterList(savedFilters.country_list);
      this.selectedWorkflow = this.normalizeSavedConfigFilterList(savedFilters.wf_list);
      if (this.hasSavedConfigPrinterToggle(savedFilters)) {
        this.applyConfigPrinterToggle(this.getSavedConfigPrinterToggle(savedFilters));
      }
      return this.hasSelectedConfigFilters;
    },
    async saveConfigFiltersToDb() {
      if (!this.hasSelectedConfigFilters) return;
      const obj = {
        userid: this.userId,
        pass: 2,
        json: this.buildConfigFilterSearchPayload().json,
      };
      await this.postConfigDbFilters(obj);
    },
    async loadConfigFiltersFromDb() {
      const obj = { userid: this.userId, pass: 1, json: "" };
      const savedFilters = await this.postConfigDbFilters(obj);
      if (savedFilters?.message === "NA" || !savedFilters) return false;
      return this.applySavedConfigFilters(savedFilters);
    },
    async clearConfigFiltersFromDb() {
      const obj = { userid: this.userId, pass: 2, json: "" };
      await this.postConfigDbFilters(obj);
    },
    persistConfigFilters() {
      if (!this.hasSelectedConfigFilters) {
        this.clearPersistedConfigFilters();
        return;
      }
      EncryptUtility.localStorageEncrypt("configSourcingFilters", JSON.stringify(this.buildConfigFilterSearchPayload()));
      const filters = [
        { selected: this.selectedProject, selectedKey: "CSProject", data: this.projectList, dataKey: "CSProjectData" },
        { selected: this.selectedBusiness, selectedKey: "CSBusiness", data: this.businessList, dataKey: "CSBusinessData" },
        { selected: this.selectedCountry, selectedKey: "CSCountry", data: this.countryList, dataKey: "CSCountryData" },
        { selected: this.selectedWorkflow, selectedKey: "CSWorkflow", data: this.workflowList, dataKey: "CSWorkflowData" },
      ];
      filters.forEach((filter) => {
        if (filter.selected?.length) {
          EncryptUtility.localStorageEncrypt(filter.selectedKey, JSON.stringify(filter.selected));
          if (filter.data?.length) {
            EncryptUtility.localStorageEncrypt(filter.dataKey, JSON.stringify(filter.data));
          }
        } else {
          EncryptUtility.localStorageRemoveItem(filter.selectedKey);
          EncryptUtility.localStorageRemoveItem(filter.dataKey);
        }
      });
    },
    restorePersistedConfigFilters() {
      const savedFilters = EncryptUtility.localStorageDecrypt("configSourcingFilters");
      if (savedFilters) {
        const savedPayload = JSON.parse(savedFilters);
        const savedFilterData = JSON.parse(savedPayload.json || "{}");
        this.selectedProject = savedFilterData.projkey_list || [];
        this.selectedBusiness = savedFilterData.bukey_list || [];
        this.selectedCountry = savedFilterData.country_list || [];
        this.selectedWorkflow = savedFilterData.wf_list || [];
        if (this.hasSavedConfigPrinterToggle(savedFilterData)) {
          this.applyConfigPrinterToggle(this.getSavedConfigPrinterToggle(savedFilterData));
        }
        return;
      }
      if (EncryptUtility.localStorageDecrypt("CSProject") !== null && EncryptUtility.localStorageDecrypt("CSProject") !== undefined) {
        this.selectedProject = JSON.parse(EncryptUtility.localStorageDecrypt("CSProject"));
        if (EncryptUtility.localStorageDecrypt("CSProjectData") !== null && EncryptUtility.localStorageDecrypt("CSProjectData") !== undefined) {
          this.projectList = JSON.parse(EncryptUtility.localStorageDecrypt("CSProjectData"));
        }
      }
      if (EncryptUtility.localStorageDecrypt("CSBusiness") !== null && EncryptUtility.localStorageDecrypt("CSBusiness") !== undefined) {
        this.selectedBusiness = JSON.parse(EncryptUtility.localStorageDecrypt("CSBusiness"));
        if (EncryptUtility.localStorageDecrypt("CSBusinessData") !== null && EncryptUtility.localStorageDecrypt("CSBusinessData") !== undefined) {
          this.businessList = JSON.parse(EncryptUtility.localStorageDecrypt("CSBusinessData"));
        }
      }
      if (EncryptUtility.localStorageDecrypt("CSCountry") !== null && EncryptUtility.localStorageDecrypt("CSCountry") !== undefined) {
        this.selectedCountry = JSON.parse(EncryptUtility.localStorageDecrypt("CSCountry"));
        if (EncryptUtility.localStorageDecrypt("CSCountryData") !== null && EncryptUtility.localStorageDecrypt("CSCountryData") !== undefined) {
          this.countryList = JSON.parse(EncryptUtility.localStorageDecrypt("CSCountryData"));
        }
      }
      if (EncryptUtility.localStorageDecrypt("CSWorkflow") !== null && EncryptUtility.localStorageDecrypt("CSWorkflow") !== undefined) {
        this.selectedWorkflow = JSON.parse(EncryptUtility.localStorageDecrypt("CSWorkflow"));
        if (EncryptUtility.localStorageDecrypt("CSWorkflowData") !== null && EncryptUtility.localStorageDecrypt("CSWorkflowData") !== undefined) {
          this.workflowList = JSON.parse(EncryptUtility.localStorageDecrypt("CSWorkflowData"));
        }
      }
    },
    //Reset Function
    async resetFunction() {
      this.configSourcingData = [];
      this.configSourcingDataTemp = [];
      this.totalRecords = 0;
      this.search = "";
      this.searchFilter = "";
      this.activeDashboardFilter = "";
      this.configDashboardSummary = this.buildConfigDashboardSummary([]);
      this.lpnText = "";
      this.lpnNum = "";
      this.dropOffLPNDialog = false;
      this.userAssignedLPN = "";
      this.stagingLocationLPN = "";
      this.dropLPN = false;
      this.lineKeys = [];
      this.$refs.configurationSourcing.resetValidation();
      this.getBreadCrumbLPN();
      if (this.hasSelectedConfigFilters) {
        this.persistConfigFilters();
        await this.filterSearch();
      } else {
        await this.getSearch();
      }
    },
    async getConfigurationDDL() {
      let configSourcingDdl = await usbServices.getconfigSourcingDdl("get", this.userId);
      this.projectList = configSourcingDdl.project;
      this.businessList = configSourcingDdl.business;
      this.countryList = configSourcingDdl.country;
      this.workflowList = configSourcingDdl.workflow;
      this.search = "";
      this.$refs.configurationSourcing?.resetValidation();
    },
    //Loading Local Storage items for search persistance
    async getSearch() {
      const loadedFromDb = await this.loadConfigFiltersFromDb();
      if (!loadedFromDb) {
        this.restorePersistedConfigFilters();
      }
      if (this.hasSelectedConfigFilters) {
        await this.filterSearch();
      }
    },
    //Clear Search
    async clearSearch() {
      this.clearPersistedConfigFilters();
      await this.clearConfigFiltersFromDb();
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.selectedCountry = [];
      this.selectedWorkflow = [];
      this.configSourcingData = [];
      this.configSourcingDataTemp = [];
      this.totalRecords = 0;
      this.search = "";
      this.searchFilter = "";
      this.activeDashboardFilter = "";
      this.configDashboardSummary = this.buildConfigDashboardSummary([]);
      this.lpnText = "";
      this.lpnNum = "";
      this.dropOffLPNDialog = false;
      this.userAssignedLPN = "";
      this.stagingLocationLPN = "";
      this.dropLPN = false;
      this.$refs.configurationSourcing.resetValidation();
      this.getBreadCrumbLPN();
    },
    //Breadcrumb Data
    async getBreadCrumbLPN() {
      let lpnStatus = await AddFavourite.getLPNDetails(this.userId);
      this.lpnText = lpnStatus[0]?.lpn_info;
      this.lpnNum = lpnStatus[0]?.lpn;
      this.lpnKey = this.lpnNum.replace(/-/g, "");
      if (lpnStatus[0]?.lpn !== "" && lpnStatus[0]?.lpn !== null) {
        this.dropLPN = true;
        this.userAssignedLPN = lpnStatus[0]?.lpn;
      }
    },
    quickSearch() {
      if (this.$refs.configurationSourcing.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`wc/source_config_quick_search?user_id=${this.userId}&search=${this.search}`)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let responseData = response.data.body;
              if (responseData.length !== 0) {
                const newArr = responseData.map((obj) => {
                  return {
                    ...obj,
                    relativetime: Utility.displayDateFormat(obj.relativetime),
                  };
                });
                this.updateConfigTableData(newArr);
              } else {
                this.configSourcingData = [];
                this.configSourcingDataTemp = [];
                this.totalRecords = 0;
                this.activeDashboardFilter = "";
                this.configDashboardSummary = this.buildConfigDashboardSummary([]);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: "No results found based on the criteria",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            this.totalRecords = 0;
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    async filterSearch() {
      if(
        this.selectedProject?.length === 0 && 
        this.selectedBusiness?.length === 0 &&
        this.selectedCountry?.length === 0 && 
        this.selectedWorkflow?.length === 0
      ) {
        this.configSourcingData = [];
        this.configSourcingDataTemp = [];
        this.totalRecords = 0;
        this.activeDashboardFilter = "";
        this.configDashboardSummary = this.buildConfigDashboardSummary([]);
        this.clearPersistedConfigFilters();
        return Promise.resolve();
      } else {
        this.persistConfigFilters();
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = this.buildConfigFilterSearchPayload();
        return this.axios
          .post("wc/source_config_filter_search", obj)
          .then(async (response) => {
            if (response.status == 200 || response.status == 204) {
              let responseData = response.data.body;
              if (responseData.length !== 0) {
                const newArr = responseData.map((obj) => {
                  return {
                    ...obj,
                    relativetime: Utility.displayDateFormat(obj.relativetime),
                  };
                });
                this.updateConfigTableData(newArr);
                this.persistConfigFilters();
                await this.saveConfigFiltersToDb();
              } else {
                this.configSourcingData = [];
                this.configSourcingDataTemp = [];
                this.totalRecords = 0;
                this.activeDashboardFilter = "";
                this.configDashboardSummary = this.buildConfigDashboardSummary([]);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: "No results found based on the criteria",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            this.totalRecords = 0;
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    //Source button click event
    sourceWorkflow(item) {
      this.$router.push({
        name: "configurationSourcingDetails",
        params: {
          soKey: btoa(item.so_id.toString()),
        },
      });
    },
    vacateWorkflow(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_exit?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.filterSearch();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    takeWorkflow(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_take?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.filterSearch();
            this.sourceConfigLoadSourcedLine();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Source Configuration Load Sourced Line
    sourceConfigLoadSourcedLine() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_load_sourcedline?user_id=${this.userId}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (response.data.body.message !== "NA" && response.data.body.message !== null) {
              let responseData = JSON.parse(response.data.body.message);
              this.$router.push({
                name: "configurationSourcingDetails",
                params: {
                  soKey: btoa(responseData[0].so_key.toString()),
                },
              });
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Drop Off LPN
    lpnDropOff() {
      if (this.$refs.stagingLocationCheckForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`wc/source_config_validate_dropoff_lpn?user_key=${this.userId}&bin=${this.stagingLocationLPN}`)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.getSourceConfigLineKeys();
              this.closeDropLPNDialog();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              this.stagingLocationLPN = "";
              this.$refs.stagingLocationCheckForm.resetValidation();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            this.stagingLocationLPN = "";
            this.$refs.stagingLocationCheckForm.resetValidation();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Get Source Configuration Line Keys
    async getSourceConfigLineKeys() {
      let data = await usbServices.sourceConfigLineKeys("get", this.userId, this.lpnKey);
      if (data.message !== "NA") {
        this.lineKeys = [];
        this.lineKeys = data;
        this.getSourceConfigBTOPrint();
      }
    },
    //Get Source Configuration BTO Print
    getSourceConfigBTOPrint() {
      for (let i = 0; i < this.lineKeys.length; i++) {
        if (this.lineKeys[i]?.sot_line_key !== undefined) {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.axios
            .get("usb/sourcing_configuration_kits_bto_print_html?user_id=" + this.userId + "&line_id=" + this.lineKeys[i]?.sot_line_key)
            .then((response) => {
              if (response.status == 200) {
                if (
                  this.labelValue &&
                  EncryptUtility.localStorageDecrypt("defaultName") !== undefined &&
                  EncryptUtility.localStorageDecrypt("defaultName") !== null &&
                  EncryptUtility.localStorageDecrypt("defaultName") !== ""
                ) {
                  Utility.printZPLPDF(response.data.body.message, EncryptUtility.localStorageDecrypt("defaultName"));
                }
                this.resetFunction();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                var Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        }
      }
    },
    //Close Drop Off LPN Dialog
    closeDropLPNDialog() {
      this.dropOffLPNDialog = false;
      this.stagingLocationLPN = "";
      this.$refs.stagingLocationCheckForm.resetValidation();
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },
    async onChangeLabelFunction(val) {
      this.labelValue = val;
      EncryptUtility.localStorageEncrypt("LabelSwitchValue", JSON.stringify(this.labelValue));
      if (this.hasSelectedConfigFilters) {
        this.persistConfigFilters();
        await this.saveConfigFiltersToDb();
      }
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
